import { useEffect } from 'react';

const SeoJsonLd = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Store',
    '@id': `${siteUrl}/#store`,
    name: 'Beauty Deals CR',
    description:
      'Distribuidores autorizados de skincare en Costa Rica. Especializados en La Roche-Posay y marcas internacionales de cuidado de la piel testadas clínicamente.',
    url: siteUrl,
    logo: {
      '@type': 'ImageObject',
      url: 'https://static.readdy.ai/image/0c9ab602efd3f666fe992585e0daf840/7111f617ff52b664a5493fd29ab7be63.jpeg',
    },
    image: 'https://static.readdy.ai/image/0c9ab602efd3f666fe992585e0daf840/7111f617ff52b664a5493fd29ab7be63.jpeg',
    telephone: '+50661025212',
    email: 'beautydealscr@gmail.com',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CR',
      addressRegion: 'Costa Rica',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 9.7489,
      longitude: -83.7534,
    },
    areaServed: {
      '@type': 'Country',
      name: 'Costa Rica',
    },
    sameAs: [
      'https://www.instagram.com/beautydeals_cr',
      'https://www.facebook.com/share/1CDauG7Y85/',
      'https://www.tiktok.com/@beautydealscr',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+50661025212',
      contactType: 'customer service',
      contactOption: 'TollFree',
      areaServed: 'CR',
      availableLanguage: 'Spanish',
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Skincare distribuidores autorizados Costa Rica',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Product',
            name: 'La Roche-Posay Skincare',
            description: 'Productos dermatológicos certificados y testados clínicamente para el cuidado de la piel.',
            brand: { '@type': 'Brand', name: 'La Roche-Posay' },
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Product',
            name: 'Sérum Vitamina C',
            description: 'Sérum antioxidante para iluminar y proteger la piel, testado clínicamente.',
            brand: { '@type': 'Brand', name: 'Beauty Deals CR' },
          },
        },
      ],
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/#webpage`,
    url: siteUrl,
    name: 'Beauty Deals CR | Distribuidores Autorizados Skincare Costa Rica',
    description:
      'Beauty Deals CR, distribuidores autorizados de skincare en Costa Rica. La Roche-Posay y marcas internacionales certificadas con envíos a todo el país.',
    inLanguage: 'es-CR',
    isPartOf: {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'Beauty Deals CR',
      publisher: { '@id': `${siteUrl}/#store` },
    },
    about: { '@id': `${siteUrl}/#store` },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Inicio',
          item: siteUrl,
        },
      ],
    },
  };

  useEffect(() => {
    const insertJsonLd = (id: string, data: object) => {
      let script = document.getElementById(id) as HTMLScriptElement | null;
      if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(data);
    };

    insertJsonLd('jsonld-organization', organizationSchema);
    insertJsonLd('jsonld-webpage', webPageSchema);

    return () => {
      ['jsonld-organization', 'jsonld-webpage'].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteUrl]);

  return null;
};

export default SeoJsonLd;
